/**
 * @param props
 */

export default (props) => {
    return {
        loading: false,
        mounted() {

        },
        subscribe() {
            if (this.service..guest === true) {
                this..visible = true;
                this..loaded = true;
                return;
            }
            this.loading = true;

            fetch( this.service.channel.subscribed ? this.service.channel.links.unsubscribe : this.service.channel.links.subscribe,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        [this.service.security.csrfToken.name]: this.service.security.csrfToken.value,
                        channel_id: this.service.channel.id,
                    })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.loading = false;
                    this.service.channel.subscribed = !this.service.channel.subscribed;
                })
        }
    }
};
